module.exports = __webpack_public_path__ + "img/measurement_info_back_hips_left.dd9909ef.jpg";